import { TripGroupingFilters } from '../../types/models/trip-grouping/trip-grouping'

export const transformTripGroupingFiltersToUrl = (filters?: TripGroupingFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.years && filters.years.length) searchParams.append('years', filters.years.join(','))

  return searchParams.toString()
}

export const transformUrlToTripGroupingFilters = (
  searchParams: URLSearchParams
): TripGroupingFilters => {
  const filters: TripGroupingFilters = {}

  const years = searchParams.get('years')
  if (years && years.length) filters.years = years.split(',').map(Number)

  return filters
}
